/**
 * PATH: packages/ui/src/kanban/components/board-table/constants.ts
 * FILE_ID: UI-KANBAN-TABLE-CONST-001
 * PURPOSE: Render-free constants for the board Table view: priority
 *          labels/classes and the row-virtualization gate.
 */

export const PRIORITY_LABEL: Record<number, string> = {
  0: 'Low',
  1: 'Normal',
  2: 'High',
  3: 'Urgent',
}

export const PRIORITY_CLS: Record<number, string> = {
  0: 'text-neutral-500',
  1: 'text-blue-600',
  2: 'text-amber-600',
  3: 'text-red-600',
}

// PERF — prod has 14k-card Trello-import boards whose Table view mounted
// one <tr> per card. Above this row count the tbody windows with
// @tanstack/react-virtual; at or under it the table renders every row
// exactly as before (keeps small boards simple, plain cmd-A copy/paste
// intact, and existing tests stable). 200 comfortably covers human-scale
// boards while capping the mounted node count on mega-boards.
export const TABLE_VIRTUALIZE_THRESHOLD = 200

/** Estimated row height (px) for the virtualizer before measureElement
 *  corrects real heights — a title-only row is ~37px, title+summary ~53px. */
export const TABLE_ROW_ESTIMATE = 44
